<app-activity
  *ngIf="id"
  [model]="'entities/providers'"
  [modelId]="id"
></app-activity>
